const navbarAll = "#ffffff"
const darkAll = "#000000"
const secondColorAll = "#27b88b"


export const header = "#012a45";
// export const navbar = "#000000";
// export const lightText = "#4f4c4c";
export const darkText = "#000000";
export const lightButton = "#eeecff";
export const darkButton = "#cf2727";
export const dimBackground = "#e6e3e3";
export const lightBackground = "#022066";
export const darkBackground = "#ffffff";
export const white = "#ffffff";
export const black = "#1a2131";

//theme color for Brand Invoice

export const currency = "GBP";// USD , GBP
export const brandName = "Harvard University Help";
export const brandUrl = "harvarduniversityhelp.co.uk";
// export const navbar = "linear-gradient(45deg,#ffc600 1%,#ff6c00 100%)";
export const navbar = "#041326";
export const navbarText = darkAll;
export const lightText = "#ACACAC";
export const mainBackgound = darkAll;
export const invoiceCard = "#2eb1dd";
export const button = "#FD0003";
export const cardBackground = "#f3f3f5";
export const lightBorder = "#E2E2E2";
export const darkGradient = "linear-gradient(135deg,rgb(15, 41, 76) 0%,rgb(99, 212, 250) 100%)";
// export const darkGradient = "#022066";



// 002e47

